import React, { PropsWithChildren } from 'react';
import { SubmitHandler, useFormContext } from 'react-hook-form';

import { ICreateBenefitGroupForm } from '@epi-models/pages/BenefitGroups';

type BenefitGroupFormProps = PropsWithChildren<{
  handleSubmitForm: SubmitHandler<ICreateBenefitGroupForm>;
}>;

export const BenefitGroupForm = ({
  handleSubmitForm,
  children
}: BenefitGroupFormProps) => {
  const { handleSubmit } = useFormContext<ICreateBenefitGroupForm>();

  return <form onSubmit={handleSubmit(handleSubmitForm)}>{children}</form>;
};
